import React from 'react';
import { useTranslation } from 'react-i18next';

interface ReferralProgressProps {
  currentPoints: number;
  nextRankPoints: number;
}

export const ReferralProgress: React.FC<ReferralProgressProps> = ({
  currentPoints,
  nextRankPoints,
}) => {
  const { t } = useTranslation();
  
  // Вычисляем процент прогресса и защищаемся от деления на ноль
  const totalPointsNeeded = currentPoints + nextRankPoints;
  const progress = totalPointsNeeded > 0 ? Math.min((currentPoints / totalPointsNeeded) * 100, 100) : 0;
  
  console.log('[ReferralProgress] Calculated:', { 
    progress, 
    currentPoints, 
    nextRankPoints,
    totalPointsNeeded 
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-end">
        <div className="flex items-baseline gap-1">
          <span 
            className="text-xl font-semibold"
            style={{
              background: 'linear-gradient(135deg, #FF0080, #FF6B00)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {currentPoints}
          </span>
          <span className="text-sm text-tg-hint mx-0.5">/</span>
          <span className="text-sm text-tg-hint">{totalPointsNeeded}</span>
        </div>
        <span className="text-xs text-tg-hint">
          {t('PROFILE_SCREEN.REFERRAL.POINTS_TO_NEXT_RANK', { points: nextRankPoints })}
        </span>
      </div>
      
      <div className="h-2 bg-tg-secondary-bg rounded-sm overflow-hidden border border-pink-500/10">
        <div 
          className="h-full bg-gradient-pink rounded-sm transition-all duration-300"
          style={{ width: `${progress}%` }} 
        />
      </div>
    </div>
  );
}; 